import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

// Tempo real (socket.io): a API avisa quando a pelada ou a partida mudam e as telas recarregam sozinhas.
// Uma conexão só para o app todo, aberta quando a primeira tela assina e fechada quando a última sai.
const URL_API = process.env.REACT_APP_API_URL || 'https://rivierafc-api.onrender.com';

let socket = null;
const ouvintes = new Set();

// Enquanto o usuário arrasta um card, os avisos ficam guardados e só são aplicados ao soltar
// (recarregar no meio do arraste faria a lista "pular" debaixo do dedo).
let arrastando = false;
let adiados = new Set();

function lerToken() {
  try {
    const token = JSON.parse(localStorage.getItem('token'));
    return token && token !== '""' ? token : null;
  } catch (error) {
    return null;
  }
}

function distribuir(canais) {
  if (arrastando) {
    canais.forEach((c) => adiados.add(c));
    return;
  }
  ouvintes.forEach((ouvinte) => ouvinte(canais));
}

function conectar() {
  if (socket) return;
  socket = io(URL_API, {
    auth: (cb) => cb({ token: lerToken() }), // token atual a cada (re)conexão
    transports: ['websocket', 'polling'],
    reconnectionDelayMax: 10000,
  });
  socket.on('atualizado', ({ canais = [] } = {}) => distribuir(canais));
  // Ao voltar a conexão (ex.: celular saiu da tela e voltou), pode ter perdido avisos: recarrega tudo.
  socket.io.on('reconnect', () => distribuir(['pelada', 'partida']));
}

function desconectarSeOcioso() {
  if (socket && ouvintes.size === 0) {
    socket.disconnect();
    socket = null;
  }
}

/** Informe o início/fim de um arraste; ao soltar, aplica os avisos que chegaram no meio. */
export function marcarArraste(ativo) {
  arrastando = ativo;
  if (!ativo && adiados.size) {
    const canais = [...adiados];
    adiados = new Set();
    distribuir(canais);
  }
}

/**
 * Chama `aoAtualizar(canais)` quando a pelada/partida muda no servidor (`canais`: 'pelada' e/ou 'partida').
 * Só conecta com usuário logado.
 */
export default function useTempoReal(aoAtualizar, { ativo = true } = {}) {
  const callback = useRef(aoAtualizar);
  callback.current = aoAtualizar;

  useEffect(() => {
    if (!ativo || !lerToken()) return undefined;
    const ouvinte = (canais) => callback.current(canais);
    ouvintes.add(ouvinte);
    conectar();
    return () => {
      ouvintes.delete(ouvinte);
      desconectarSeOcioso();
    };
  }, [ativo]);
}
